var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.purchase.contract ||
      _vm.purchase.actions.customer.contract !== "disallow"
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center",
                },
                [
                  _c(
                    "text-header",
                    {
                      staticClass: "atmo-hash-jump-point",
                      attrs: { id: "atmo-contract" },
                    },
                    [_vm._v("Контракт")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.purchase.contract
        ? _c("fl44-unknown-volume-purchase-contract-info", {
            attrs: { purchase: _vm.purchase },
            on: {
              refresh: function ($event) {
                return _vm.refresh($event)
              },
            },
          })
        : _vm._e(),
      _vm.$store.getters.isLoggedIn &&
      _vm.purchase.is_customer &&
      _vm.purchase.actions.customer.contract !== "disallow"
        ? _c("private-fl44-unknown-volume-contract-customer-block", {
            attrs: { purchase: _vm.purchase },
            on: {
              refresh: function ($event) {
                return _vm.refresh($event)
              },
            },
          })
        : _vm._e(),
      _vm.$store.getters.isLoggedIn &&
      _vm.purchase.is_supplier &&
      _vm.purchase.actions.supplier.contract !== "disallow"
        ? _c("private-fl44-unknown-volume-contract-supplier-block", {
            attrs: { purchase: _vm.purchase },
            on: {
              refresh: function ($event) {
                return _vm.refresh(null)
              },
            },
          })
        : _vm._e(),
      _vm.purchase.flags.has_contract && _vm.purchase.contract
        ? _c("fl44-unknown-volume-supplementary-agreement-block", {
            attrs: { purchase: _vm.purchase },
            on: {
              refresh: function ($event) {
                return _vm.refresh($event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }